import * as appConstant from "../constants/appConstant";

const generateRoute = ({Filters, Dimensions, Buttons, ContentWrapper, BulkUploadWrapper}) => {
    return [{
        titleMessage: {
            id: "campaigns_title",
            defaultMessage: appConstant.APP_TITLE
        },
        path: "/",
        layout: {
            filters: !!Filters,
            dimensions: !!Dimensions,
            Buttons: !!Buttons,
            pageTitle: true,
            sidenav: false
        },
        rightPanelIconVisible : !!Filters,
        Filters,
        Dimensions,
        Buttons,
        Content: ContentWrapper
    }, {
        titleMessage: {
            id: "campaigns_title",
            defaultMessage: appConstant.APP_TITLE
        },
        path: appConstant.ROUTE_BULK_UPLOAD,
        layout: {
            filters: false,
            dimensions: false,
            Buttons: false,
            pageTitle: false,
            sidenav: false
        },
        Filters,
        Dimensions,
        Buttons,
        Content: BulkUploadWrapper
    }]
}

export default generateRoute;